import React from "react";
import youtubeIcon from "../../resources/images/youtubeIcon.svg";
import youtubeWhiteIcon from "../../resources/images/youtubeWhiteIcon.svg";
import communityIcon from "../../resources/images/communityIcon.svg";
import eventsIcon from "../../resources/images/eventsIcon.svg";
import blogsIcon from "../../resources/images/blogsIcon.svg";
import styles from "./freelearning.module.css";
import { NAV_LINK_CONSTANTS } from "../Header/NavLinksContants";

export default function FreeLearningHoverBox({ isMobileFree = false }) {
    // Function to disable scroll
    const disableScroll = () => {
        document.body.style.overflow = "hidden"; // Disable scrolling
    };

    // Function to enable scroll
    const enableScroll = () => {
        document.body.style.overflow = "auto"; // Enable scrolling
    };

    return (
        <div className={styles.resourcesContainer}>
            <div
                className={styles.resourcesText}
                onMouseEnter={!isMobileFree ? disableScroll : null}
                onMouseLeave={!isMobileFree ? enableScroll : null}
            >
                <div className={styles.resourcesDiv}>
                    <a
                        href={NAV_LINK_CONSTANTS.CORPORATE_AI_DL_PROGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <div className={styles.resourcesCoursesTitleArrow}>
                            <div className={styles.resourcesHeading}>Free Communities</div>
                        </div>
                        <div className={styles.freeLearningLink}>Interview Preparations</div>
                    </a>
                </div>
            </div>
        </div>
    );
}
